<template>
  <div v-if="show" class="snackbar success" :class="{ 'slide-in': show }">
    {{ message }}
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      default: 'Operation successful!'
    },
    duration: {
      type: Number,
      default: 3000
    }
  },
  data() {
    return {
      show: false
    }
  },
  methods: {
    showNotification() {
      this.show = true
      setTimeout(() => {
        this.show = false
      }, this.duration)
    }
  }
}
</script>

<style scoped>
.snackbar {
  position: fixed;
  top: 24px;
  right: 24px;
  padding: 12px 24px;
  border-radius: 8px;
  color: white;
  font-weight: 500;
  font-size: 15px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  z-index: 9999;
  min-width: 240px;
  text-align: center;
  opacity: 0;
  transform: translateY(-20px);
  transition: all 0.4s ease;
}

.snackbar.slide-in {
  opacity: 1;
  transform: translateY(0);
}

.success {
  background: #4caf50;
}
</style>